// Canonical Amplitude event registry for the Service Job Templates surface.
// Event names are silent contracts with Amplitude dashboards: always import
// from here instead of inlining strings.

export const CREATED = "job_templates:created"
export const EDITED = "job_templates:edited"
export const DELETED = "job_templates:deleted"
export const RESTORED = "job_templates:restored"
